// Chakra imports
import {
  Alert,
  AlertDescription,
  AlertDialog,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertIcon,
  AlertTitle,
  CloseButton,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
// Custom components

export default function PopOverAlert(props: {
  handleOpenAlert?: any;
  isOpen?: boolean;
  title?: string;
  subtitle?: string;
  status?: any;
  [x: string]: any;
}) {
  const { handleOpenAlert, isOpen, title, subtitle, status } = props;
  const { onClose } = useDisclosure();
  const cancelRef = React.useRef();

  useEffect(() => {
    if (isOpen)
      setTimeout(() => {
        handleOpenAlert(false);
      }, 4000);
  }, [isOpen, handleOpenAlert]);

  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <Alert
              borderRadius="5px"
              padding="30px"
              status={status}
              variant="solid"
            >
              <Flex>
                <AlertIcon />
                <Flex direction="column">
                  <AlertTitle mr="12px">{title}</AlertTitle>
                  <AlertDescription>{subtitle}</AlertDescription>
                </Flex>
              </Flex>
              <CloseButton
                position="absolute"
                right="8px"
                top="8px"
                onClick={() => handleOpenAlert(false)}
              />
            </Alert>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
